import { ApplicationContextProvider } from "components/ApplicationContextProvider";
import ReactGA from "react-ga4";
import ApplicationShell from "components/ApplicationShell";
import NotificationPortal from "components/Notifications/NotificationPortal";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthorizeScreen from "./Screens/AuthorizeScreen";
import DashboardScreen from "./Screens/DashboardScreen";
import IndexScreen from "Screens/IndexScreen";
import UserScreen from "Screens/UserScreen";
import UserEditScreen from "Screens/UserScreen/EditScreen";
import ProfileScreen from "Screens/ProfileScreen";
import PublicationScreen from "Screens/PublicationScreen";
import GroupScreen from "Screens/GroupScreen";
import GroupEditScreen from "Screens/GroupScreen/EditScreen";
import Modal from "components/Modal";

function App() {
    if (
        process.env.REACT_APP_GA_TRACKING_ID &&
        process.env.NODE_ENV === "production"
    ) {
        ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
    } else {
        console.info("GA tracking disabled");
    }
    return (
        <ApplicationContextProvider>
            <Router>
                {/*<ScrollTop />*/}
                <Switch>
                    <Route exact path="/" component={IndexScreen} />
                    <Route path="/authorize" component={AuthorizeScreen} />
                    <ProtectedRoute path="/app">
                        <ApplicationShell>
                            <Route
                                path="/app"
                                exact
                                component={DashboardScreen}
                            />
                            <Route
                                path="/app/dashboard"
                                component={DashboardScreen}
                            />
                            <Route
                                path="/app/profile"
                                component={ProfileScreen}
                            />
                            <Route
                                path="/app/user"
                                component={UserScreen}
                                exact
                            />
                            <Route
                                path="/app/user/:uuid"
                                component={UserEditScreen}
                            />
                            <Route
                                path="/app/group"
                                component={GroupScreen}
                                exact
                            />
                            <Route
                                path="/app/group/:groupId"
                                component={GroupEditScreen}
                            />
                            <Route
                                path="/app/publication"
                                component={PublicationScreen}
                            />
                        </ApplicationShell>
                    </ProtectedRoute>
                </Switch>
            </Router>
            <NotificationPortal />
            <Modal />
        </ApplicationContextProvider>
    );
}

export default App;
